import type { Context } from 'react'
import { createContext } from 'react'
import { TIMELINE_ACTION_BUTTON_INITIAL_VALUES } from './constants'
import type { TimelineActionButtonContextT } from './types'

const TimelineActionButtonContext: Context<TimelineActionButtonContextT> = createContext(
  TIMELINE_ACTION_BUTTON_INITIAL_VALUES,
)

export default TimelineActionButtonContext
